export default __webpack_public_path__ + "static/media/amal.c929235f.jpg";